import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { imageUrl, postPath } from "@opinly/shared";
import { formatPostDate } from "../../lib/opinly";

export const PostCard = ({ post, config, featured = false }) => {
  const img = config.imagesPrefix && post.image?.fileKey ? imageUrl(post.image.fileKey, config) : null;
  return (
    <Link
      to={postPath(config, post)}
      data-testid={`blog-post-card-${post.slug}`}
      className={`group mps-card overflow-hidden flex flex-col ${featured ? "md:col-span-2 lg:grid lg:grid-cols-2" : ""}`}
    >
      {img ? (
        <div className={`overflow-hidden bg-brand-surface ${featured ? "aspect-[16/9] lg:aspect-auto lg:h-full" : "aspect-[16/9]"}`}>
          <img src={img} alt={post.image?.alt || ""} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
        </div>
      ) : (
        <div className={`${featured ? "hidden lg:block" : "hidden"} bg-[linear-gradient(135deg,#0A2342_0%,#12355B_60%,#2F80ED_140%)]`} aria-hidden />
      )}
      <div className={`flex flex-col flex-1 ${featured ? "p-8 lg:p-10" : "p-6"}`}>
        {post.category?.name && <div className="eyebrow mb-3" data-testid="blog-post-card-category">{post.category.name}</div>}
        <h2 className={`font-display font-semibold tracking-tight text-brand-navy leading-snug ${featured ? "text-2xl md:text-3xl" : "text-xl"}`}>
          {post.title}
        </h2>
        {post.description && <p className="mt-3 text-sm md:text-base text-brand-muted leading-relaxed line-clamp-3">{post.description}</p>}
        <div className="mt-auto pt-6 flex items-center justify-between text-xs text-brand-muted">
          <span>{formatPostDate(post.firstPublishedAt)}{post.author?.name ? ` · ${post.author.name}` : ""}</span>
          <span className="inline-flex items-center gap-1 font-semibold text-brand-accent">
            Read <ArrowRight size={12} weight="bold" className="transition-transform duration-200 group-hover:translate-x-0.5" />
          </span>
        </div>
      </div>
    </Link>
  );
};
